import { User } from "@/modules/user";


export class StorageService {
  static #instance: StorageService;

  private constructor() {}

  public static get instance() {
    if (!this.#instance) {
      this.#instance = new StorageService();
    }

    return this.#instance;
  }

  getUseLocalStorage() {
    return window.localStorage.getItem("useLocalStorage") === "true";
  }
  setUseLocalStorage(value: boolean) {
    window.localStorage.setItem('useLocalStorage', value ? "true" : "false");
  }

  getValue(key: string): string | null {
    const useLocalStorage = this.getUseLocalStorage();

    return useLocalStorage
      ? window.localStorage.getItem(key)
      : window.sessionStorage.getItem(key);
  }

  getJWTToken(): string | null {
    const useLocalStorage = this.getUseLocalStorage();

    return useLocalStorage
      ? window.localStorage.getItem("jwtToken")
      : window.sessionStorage.getItem("jwtToken");
  }

  getRefreshToken(): string | null {
    const useLocalStorage = this.getUseLocalStorage();

    return useLocalStorage
      ? window.localStorage.getItem("refreshToken")
      : window.sessionStorage.getItem("refreshToken");
  }

  getCurrentUser(): User | null {
    const useLocalStorage = this.getUseLocalStorage();
    const user: string | null = useLocalStorage
      ? window.localStorage.getItem("currentUser")
      : window.sessionStorage.getItem("currentUser"); 
    
    if (user) {
      return JSON.parse(user) as User;
    }
    return null;
  }

  setValue(key: string, value: string) {
    const useLocalStorage = this.getUseLocalStorage();

    if (useLocalStorage) {
      window.localStorage.setItem(key, value);
    } else {
      window.sessionStorage.setItem(key, value);
    }
  }

  setJwtToken(jwt: string) {
    this.setValue("jwtToken", jwt);
  }

  setTokens(jwt: string, refresh: string) {
    this.setValue("jwtToken", jwt);
    this.setValue("refreshToken", refresh);
  }

  setUser(user: User) {
    this.setValue("currentUser", JSON.stringify(user));
  }

  removeValue(key: string) {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  }

  clear() {
    this.removeValue("jwtToken");
    this.removeValue("refreshToken");
    this.removeValue("currentUser");
  }
}